import { makeAutoObservable, runInAction } from 'mobx';
import { CheckboxFiltersStore } from '../model';

const storeLocationFilters = makeAutoObservable<CheckboxFiltersStore>({
  list: [],
  label: 'Type of location',
  alias: 'type_of_location',
  setList(list) {
    runInAction(() => {
      storeLocationFilters.list = Object.entries(list)
        .map(([key, value]) => ({ id: parseInt(key), label: value }));
    });
  },
});

export default storeLocationFilters;
